import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './LoginPage.css';
import { useAuth } from '../../components/AuthProvider';
import { useComponentLoading } from '../../utils/useComponentLoading';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();
  const { withLoading, isLoading } = useComponentLoading();

  useEffect(() => {
    if (location.state && location.state.error) {
      setError(location.state.error);
      // Clear the error from history so it doesn't persist on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setError("");
    try {
      const success = await withLoading('login', async () => {
        return await login({ email:username,username, password });
      }, 'Logging in...');
      if (success) {
        navigate('/login/home');
      } else {
        throw new Error("Invalid username or password");
      }
    } catch (err) {
      navigate('/', { state: { error: err.message || "Login failed" } });
    }
  };

  return (
    <div className="login-page">
      <div className="logo">VendorBooks</div>
      <div className="car-image">
        <img src="/carImage.png" alt="Car" />
      </div>
      <div className="login-box">
        <form className="login-form" onSubmit={handleLogin} noValidate>
          <h2>Login</h2>
          {error && <p className="error">{error}</p>}
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username/Email"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button type="submit" className={isLoading('login') ? "submitButton loading" : "submitButton"} disabled={isLoading('login')}>
            {isLoading('login') ? <LoadingSpinner size="small" inline={true} message="" /> : 'Login'}
          </button>
        </form>
      </div>
      <div className="nav-links">
        <a href="/help">Help</a>
        <a href="/discover">Discover</a>
        <a href="/signup">Signup</a>
      </div>
    </div>
  );
}

export default Login;
